import IsOnBoardingCheck from "./IsOnBoardingCheck";

export default IsOnBoardingCheck;